import { Box, Stack } from '@mui/material'

import type {
  Estimate,
  Estimate as GraphqlEstimate,
  PaymentLink,
} from '~/api/graphql/generated/types'
import { TableTextNavigateCell } from '~/components/dashboard/clients/balance/table/common/TableTextNavigateCell'
import { TableTextWithClickCell } from '~/components/dashboard/clients/balance/table/common/TableTextWithClickCell'
import InvoiceType from '~/constants/InvoiceType'
import { getInvoiceType } from '~/utils/refundUtils'

import { CLIENT_BILLING_ACTIVITY_CELL_MIN_HEIGHT } from '../common/tableConstants'

interface TableInvoiceEstimateCellProps {
  estimateInvoices: PaymentLink[]
  onEstimateNameClick: (data: GraphqlEstimate) => void
  setInitialItemQueryParam?: (index?: number) => void
  tableRowIndex?: number
}

export const TableInvoiceEstimateCell = ({
  estimateInvoices,
  onEstimateNameClick,
  setInitialItemQueryParam,
  tableRowIndex,
}: TableInvoiceEstimateCellProps) => {
  if (!estimateInvoices) {
    return null
  }

  return (
    <Stack>
      {estimateInvoices.map((link) => {
        const type = getInvoiceType(link.invoiceNo)

        if (type === InvoiceType.INVOICE) {
          return (
            <Box
              alignItems="center"
              display="flex"
              height={CLIENT_BILLING_ACTIVITY_CELL_MIN_HEIGHT}
              key={link.invoiceNo}
              width="100%"
            >
              <TableTextNavigateCell
                openOnTheSameTab
                index={tableRowIndex}
                setInitialItemQueryParam={setInitialItemQueryParam}
                to={`/invoice/${link.invoice.id}`}
                value={link.invoiceNo}
              />
            </Box>
          )
        }
        if (type === InvoiceType.REFUND_INVOICE) {
          return (
            <Box
              alignItems="center"
              display="flex"
              height={CLIENT_BILLING_ACTIVITY_CELL_MIN_HEIGHT}
              key={link.invoiceNo}
              width="100%"
            >
              <TableTextNavigateCell
                openOnTheSameTab
                index={tableRowIndex}
                setInitialItemQueryParam={setInitialItemQueryParam}
                to={`/refund/${link.invoice.id}`}
                value={link.invoiceNo}
              />
            </Box>
          )
        }
        if (type === InvoiceType.ESTIMATE) {
          const estimate = link.invoice as Estimate
          return (
            <Box
              alignItems="center"
              display="flex"
              height={CLIENT_BILLING_ACTIVITY_CELL_MIN_HEIGHT}
              key={link.invoiceNo}
              width="100%"
            >
              <TableTextWithClickCell
                value={link.invoiceNo}
                onClick={() => {
                  setInitialItemQueryParam?.(tableRowIndex)
                  onEstimateNameClick({
                    invoiceIds: [],
                    personId: '',
                    clientId: estimate.clientId,
                    patientId: estimate.patientId,
                    id: estimate.id,
                    businessId: estimate.businessId,
                    creationDate: estimate.creationDate,
                    modificationDate: estimate.modificationDate,
                  })
                }}
              />
            </Box>
          )
        }
        return null
      })}
    </Stack>
  )
}
